import { useContext, useEffect } from 'react';
import { UserContext } from '@namespace/user';
import { getUnreadMessagesCount } from '../../api/getUnreadMessagesCount';
import {
  notificationCenterActions,
  useNotificationCenterStore
} from '../../store';

const { UPDATE_MESSAGES_COUNT } = notificationCenterActions;

export const useUpdateMessagesCount = () => {
  const { messageDetails, messages } = useNotificationCenterStore([
    'messageDetails',
    'messages'
  ]);
  const [, userActions] = useContext(UserContext);
  const { SET_COUNTERS } = userActions;

  useEffect(() => {
    (async () => {
      const { messagesCount } = await getUnreadMessagesCount();

      SET_COUNTERS(messagesCount);
    })();
    // Fetch messages count on initial load, after loading messages list and
    // after loading the message details to always have the correct count
  }, [UPDATE_MESSAGES_COUNT, messages, messageDetails, SET_COUNTERS]);
};
